package chand.wordvoyage.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import chand.wordvoyage.repository.AuthRepository
import chand.wordvoyage.repository.AuthState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AuthViewModel(private val authRepository: AuthRepository) : ViewModel() {

    private val _authState = MutableStateFlow(authRepository.getCurrentUser())
    val authState: StateFlow<AuthState> = _authState.asStateFlow()


    fun signInWithGoogle(idToken: String) {
        viewModelScope.launch {
            _authState.value = AuthState.Loading
            authRepository.signInWithGoogle(idToken)
                .onSuccess { state -> _authState.value = state }
                .onFailure { e ->
                    println("Auth Error: ${e.message}")
                    _authState.value = AuthState.NotAuthenticated
                }
        }
    }

    fun signOut() {
        authRepository.signOut()
        _authState.value = AuthState.NotAuthenticated
    }

    fun deleteAccount(onComplete: (Result<Unit>) -> Unit) {
        viewModelScope.launch {
            _authState.value = AuthState.Loading
            val result = authRepository.deleteAccount()
            if (result.isSuccess) {
                _authState.value = AuthState.NotAuthenticated
            } else {
                _authState.value = authRepository.getCurrentUser()
            }
            onComplete(result)
        }
    }
}

